// export const API_BASE_URL = "http://localhost:8000";
export const API_BASE_URL = "https://landcalc-backend.vercel.app";

export type SessionManager = {
  getToken: () => string | null;
  setToken: (token: string) => void;
  signOut: () => void;
  getData: (endpoint: string) => Promise<any>;
};
